import { render, staticRenderFns } from "./SiloPropertyCreate.vue?vue&type=template&id=7a423525"
import script from "./SiloPropertyCreate.vue?vue&type=script&lang=js"
export * from "./SiloPropertyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports